import {Link} from "react-router";
import {srcUrl} from "@/api/ImageApi.ts";
import type {Dungeon} from "@/dungeons/model/Dungeon.ts";
import {dungeonCardImage} from "@/dungeons/dungeonCardImage.ts";

export default function DungeonCard({dungeon, to}: {dungeon: Dungeon; to: string}) {
    const image = dungeonCardImage(dungeon);
    return <Link to={to}
        className="group overflow-hidden rounded-xl border border-border/80 bg-card/90 shadow-lg shadow-black/10 transition-all duration-200 hover:-translate-y-1 hover:border-primary/60 hover:shadow-xl hover:shadow-primary/10 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50">
        <div className="relative h-40 overflow-hidden bg-surface">
            {image && <img src={srcUrl(image)} alt="" className="size-full object-cover"/>}
            <div className="pointer-events-none absolute inset-0 bg-linear-to-t from-card/65 to-transparent"/>
        </div>
        <div className="p-4">
            <h2 className="font-semibold group-hover:text-primary">{dungeon.name}</h2>
            <p className="mt-1 text-sm text-muted-foreground">{dungeon.levels.length} Level</p>
        </div>
    </Link>;
}
